import { Injectable, Optional } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthModuleConfig, OAuthResourceServerErrorHandler, OAuthStorage } from 'angular-oauth2-oidc';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    private ignoredUrls: string[] = ['/api/public'];

    constructor(private authStorage: OAuthStorage,
                private errorHandler: OAuthResourceServerErrorHandler,
                @Optional() private moduleConfig: OAuthModuleConfig) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.ignoredUrls.find(url => req.url.indexOf(url) >= 0)) {
            return next.handle(req);
        }
        const token = this.authStorage.getItem('access_token');
        const header = 'Bearer ' + token;
        const headers = req.headers.set('Authorization', header);
        req = req.clone({headers});
        return next.handle(req)
            .pipe(catchError(err => this.errorHandler.handleError(err)));
    }
}
